(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smsbump_subscription_form_embed_334768"] && !Shopify.designMode) return;
  try {
    
// Wait for the Yotpo form to load and apply additional styling
document.addEventListener('DOMContentLoaded', function() {
  // Function to apply styles when form loads
  function enhanceYotpoForm() {
    // Look for various possible form containers
    const formSelectors = [
      '[id^="smsbump-form"]',
      '.smsbump-form-container',
      '.smsbump-embedded-form',
      'div[class*="yotpo"]',
      'div[class*="smsbump"]',
      'form[class*="yotpo"]',
      'form[class*="smsbump"]'
    ];
    
    let formFound = false;
    
    formSelectors.forEach(selector => {
      const forms = document.querySelectorAll(selector);
      if (forms.length > 0) {
        formFound = true;
        forms.forEach(form => {
          // Add a class for easier styling
          form.classList.add('enhanced-safari-form');
          
          // Ensure form is visible and styled
          form.style.cssText += `
            background: 
              linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%),
              repeating-linear-gradient(
                45deg,
                rgba(255, 69, 0, 0.03) 0px,
                rgba(255, 69, 0, 0.03) 2px,
                transparent 2px,
                transparent 20px
              ) !important;
            border-radius: 20px !important;
            padding: 40px !important;
            box-shadow: 
              0 20px 40px -10px rgba(0, 0, 0, 0.1),
              0 0 0 1px rgba(255, 255, 255, 0.8),
              inset 0 1px 0 rgba(255, 255, 255, 0.9) !important;
            margin: 30px auto !important;
            max-width: 500px !important;
            position: relative !important;
            overflow: hidden !important;
            border: none !important;
          `;
        });
      }
    });
    
    return formFound;
  }
  
  // Try to enhance immediately
  if (!enhanceYotpoForm()) {
    // If form not found, wait a bit and try again
    setTimeout(() => {
      if (!enhanceYotpoForm()) {
        // Try one more time after 2 seconds
        setTimeout(enhanceYotpoForm, 2000);
      }
    }, 500);
  }
});

  } catch(e) { console.error(e); }
})();
})();
